// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export const NOT_FOUND_INTERVAL_VALUE = -1;
export var BarIndex;
(function (BarIndex) {
    BarIndex[BarIndex["Time"] = 0] = "Time";
    BarIndex[BarIndex["Open"] = 1] = "Open";
    BarIndex[BarIndex["Close"] = 2] = "Close";
    BarIndex[BarIndex["High"] = 3] = "High";
    BarIndex[BarIndex["Low"] = 4] = "Low";
    BarIndex[BarIndex["Volume"] = 5] = "Volume";
    BarIndex[BarIndex["VolumeAsk"] = 6] = "VolumeAsk";
    BarIndex[BarIndex["TimeClose"] = 7] = "TimeClose";
    BarIndex[BarIndex["Median"] = 8] = "Median";
    BarIndex[BarIndex["Typical"] = 9] = "Typical";
    BarIndex[BarIndex["Weighted"] = 10] = "Weighted";
})(BarIndex || (BarIndex = {}));
